export default __webpack_public_path__ + "static/media/dr-maz-alsaffar.11a061a2.jpg";